export enum EFulfillmentOrderAction {
  CREATE_FULFILLMENT_ORDER = 'create_fulfillment_order',
  UPDATE_FULFILLMENT_ORDER = 'update_fulfillment_order',
  DELETE_FULFILLMENT_ORDER = 'delete_fulfillment_order',
  UPDATE_STATUS_FULFILLMENT_ORDER = 'update_status_fulfillment_order',
  VIEW_FULFILLMENT_ORDER = 'view_fulfillment_order',
  PUSH_TO_FULFILLMENT_CHANNEL = 'push_to_fulfillment_channel',
  REMOVE_FROM_FULFILLMENT_CHANNEL = 'remove_from_fulfillment_channel',
}

export enum EFulfillmentOrderStatus {
  SHIPPED = 'shipped',
  AWAITING_SHIPMENT = 'awaiting_shipment',
}
